export default __webpack_public_path__ + "static/media/login_banner.248dc1cd.jfif";